import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TokenDecoder {
  constructor(@Inject(PLATFORM_ID) private platformId: string) {}

  /**
   * Returns the decoded JWT token. This does not
   * verify the token and is only used to access the payload information.
   * Verification should be done in the backend.
   *
   * @param token
   * @param transformToken Callback to check the decoded token fields and transform it to camelCase
   */
  decodeToken<T>(
    token: string,
    transformToken: (decoded: any) => T | undefined,
  ): T | undefined {
    try {
      const decodedToken = isPlatformBrowser(this.platformId)
        ? JSON.parse(atob(token.split('.')[1]))
        : // Uses `Buffer` instead as `atob` is not available for SSR.
          JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString());
      return transformToken(decodedToken);
    } catch (e: any) {
      return undefined;
    }
  }
}
